import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { DataType } from '@vendasta/automata';
import { apiToGalaxy as convertToFloat, maxValue, minValue } from '@vendasta/auxiliary-data-components';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { v4 as uuidv4 } from 'uuid';
import { AutomationVariableMenuComponent, insertVariable } from '../../../../../../common/components';
import { DynamicEntryComponent, DynamicEntryComponentCrmConfig, DynamicOptionsComponent } from '../dynamic-options';

@Component({
  selector: 'automata-auxiliary-data-currency-input',
  templateUrl: './auxiliary-data-currency-input.component.html',
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    AutomationVariableMenuComponent,
  ],
})
export class AuxiliaryDataCurrencyInputComponent
  implements DynamicOptionsComponent, AfterViewInit, DynamicEntryComponent
{
  @Input() initialValue: number;
  @Input() showVariableItemMenu: boolean;
  @Input() label = '';
  @Input() config: DynamicEntryComponentCrmConfig;
  @Input() required = false;

  @ViewChild('input') inputElement: ElementRef;
  minValue = minValue;
  inputControl: UntypedFormControl = new UntypedFormControl(null);
  selectedValue$ = this.inputControl.valueChanges;
  currencyCode = 'USD';
  public supportedDataTypes = [DataType.DATA_TYPE_UNKNOWN];
  id = uuidv4();

  ngAfterViewInit(): void {
    if (this.initialValue !== null && this.initialValue !== undefined) {
      this.setCurrencyValue(this.initialValue);
    }
  }

  initialize(_: string, currencyCode: string): void {
    this.currencyCode = currencyCode;
  }

  getSelectedValue(): number {
    return this.inputControl.value;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.inputControl];
  }

  isFormValid(): boolean {
    return this.inputControl.valid;
  }

  key(event: any): void {
    let str: string = event.target.value;
    str = str.replace(/[^\d]/, '');
    let num: number = parseInt(str, 10);
    if (isNaN(num)) {
      num = 0;
    }
    if (num > maxValue) {
      num = maxValue;
    }
    if (num < minValue) {
      num = minValue;
    }
    this.setCurrencyValue(num);
  }

  private setCurrencyValue(v: number): void {
    this.inputControl.setValue(v);
    this.inputElement.nativeElement.value = convertToFloat(v).toFixed(2);
  }

  insertTheVariable(control: AbstractControl, variable: string): void {
    insertVariable(this.id, control, variable);
  }
}
